import React, { useState, useContext, useEffect } from 'react'
import { Tab, Tabs, Button, Card, Modal } from 'react-bootstrap';
import { FaCreditCard } from "react-icons/fa";
import { FaPix } from "react-icons/fa6";
import { BsUpc } from "react-icons/bs";
import { FaWallet } from "react-icons/fa";
import { GetUserContext } from '../../Context/GetUserContext';
import ProductCarMarketOrders from '../ProductCarMarketOrders';
import './FinalizeCart.css';
import ImageZoom from '../ImageZoom';
import formats, { formatPrice } from '../../controller/views/formats';
import pedido from '../../controller/api/Pedido';
import purchasingRule from '../../controller/views/purchasingRule';

const FinalizeCart = ({ userDatas }) => {
    const { size, habilityEntrega, setHabilityEntrega, setFetchTimestamp, setFetchTimestampApp } = useContext(GetUserContext);
    const [showF, setShowF] = useState(false);
    const [payment, setPayment] = useState(1);
    const [parcelPayment, setParcelPayment] = useState(1);
    const [obsPedido, setObsPedido] = useState('');
    const [endereco, setEndereco] = useState(`${userDatas?.address?.Name}, ${userDatas?.address?.Number} - ${userDatas?.address?.neighborhood?.Name}, ${userDatas?.address?.city?.Name} - ${userDatas?.address?.state?.Uf}, ${userDatas?.address?.Cep}`);
    const [nParcelas, setNParcelas] = useState([])
    const [descBoleto, setDescBoleto] = useState([])
    const [completeDates, setCompleteDates] = useState([])
    const [parcelBoleto, setParcelBoleto] = useState(1)
    const [escolherDataBoletoRN, setEscolherDataBoletoRN] = useState({})
    const [enderecoRetirada, setEnderecoRetirada] = useState('')
    const [utimateBoleto, setUtimateBoleto] = useState(false)
    const qtdTotal = parseFloat(localStorage.getItem('qtdTotal'));
    const [parcelasFormatadas, setParcelasFormatadas] = useState([]);
    const [currentDate, setCurrentDate] = useState();

    const handleClose = () => {
        setShowF(false)
        setParcelBoleto([])
        setEscolherDataBoletoRN({})
        setPayment(1)
    }
    const handleShowF = () => setShowF(true);
    const storedItems = JSON.parse(localStorage.getItem(`itemCardProd${userDatas?.Company_ID}`)) || [];

    useEffect(() => {
        setCurrentDate(formats?.dateNow())
    }, [])

    const Order = new pedido()
    const PurchasingRule = new purchasingRule(qtdTotal, payment, currentDate)

    useEffect(() => {
        switch (payment) {
            case 1:

                PurchasingRule.cardPayment('RN')
                    .then(response => {

                        setNParcelas(response?.parcel)
                    })
                    .catch(err => {
                        console.log(err)
                    })
                break;
            case 3:

                PurchasingRule.ticketPayment('RN')
                    .then(response => {

                        if (Array.isArray(response)) {
                            setEscolherDataBoletoRN(response)
                        } else {

                            setNParcelas(response?.parcel)
                            setDescBoleto(response?.dates)
                            setCompleteDates(response?.completeDates)
                            setUtimateBoleto(response?.boletUltmate)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
                break;

            default:
                break;
        }
    }, [qtdTotal, payment])

    useEffect(() => {
        if (utimateBoleto) {
            setParcelBoleto(formats.gerarDatasPorIntervaloAupRN(descBoleto?.date, parcelPayment?.x, descBoleto?.interval))
        } else {
            setParcelBoleto(formats.gerarDatasPorIntervalo(descBoleto?.date, parcelPayment?.x, descBoleto?.interval))
        }
    }, [parcelPayment])

    useEffect(() => {
        if (qtdTotal > 0) {
            const parcelas = nParcelas?.map(parcelasCount => {
                const valorReal = qtdTotal / parcelasCount;
                const valorTruncado = Math.floor(valorReal * 100) / 100;

                const valorFormatado = valorTruncado.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });

                return {
                    x: parcelasCount,
                    z: valorFormatado,
                    a: `${parcelasCount}x de `,
                    b: `R$ ${valorFormatado}`
                };
            });

            setParcelasFormatadas(parcelas);

            if (parcelas?.length > 0) {
                setParcelPayment(parcelas?.[0]);
            }
        }
    }, [qtdTotal, nParcelas]);

    useEffect(() => {
        if ((payment === 1 || payment === 3) && parcelasFormatadas?.length > 0) {
            setParcelPayment(parcelasFormatadas[0]);
        }
    }, [payment, parcelasFormatadas]);

    useEffect(() => {
        if (payment === 3 && parcelasFormatadas?.length > 0) {
            setParcelPayment(parcelasFormatadas[0]);
        }
    }, [payment, parcelasFormatadas]);

    const [selectedTab, setSelectedTab] = useState(1);
    const handleSelect = (key) => {
        if (key === 'Retirar') {
            setSelectedTab(1);
        } else if (key === 'Entrega') {
            setSelectedTab(2);
        }
    };

    const handleNewCompleteDatas = (date, interval) => {
        setCompleteDates(date)
        let parcel = { interval: interval }
        setDescBoleto(parcel)
    }

    const handleSendOrder = () => {
        if (payment === 4 || payment === 2) {
            const data = {
                User_ID: userDatas?.user_and_companies?.[0]?.User_ID,
                ID_Canal: 1,
                Pedido_Feito: formats.dateNow(),
                Pedido_Feito_Hora: formats.hourNow(),
                Valor: qtdTotal,
                Endereco: selectedTab === 1 ? enderecoRetirada : endereco,
                Tipo_Pedido: selectedTab,
                Observacao: obsPedido,
                Cancelado: "", Analise: "", Aprovado: "",
                Faturado: "", Enviado: "", Entregue: "",
                Company_ID: userDatas?.Company_ID,
                ID_Forma_de_Pagamento: payment,
                NParcelas: 1,
                valorParcelado: qtdTotal,
                completeDates: null,
                interval: descBoleto?.interval,
                ultimateBoleto: utimateBoleto
            }

            Order.addCarrinho(data.Company_ID, data.Valor, storedItems)
                .then(response => {

                    if (response.status == 200) {
                        Order.addPedido(data)
                            .then(response => {
                                if (response.status == 200) {
                                    console.log(response.data.menssage)
                                    localStorage.removeItem(`itemCardProd${userDatas?.Company_ID}`)

                                    setShowF(false)
                                    setFetchTimestamp(Date.now());
                                    setFetchTimestampApp(Date.now());
                                }
                            })
                            .catch(err => {
                                console.log(err)
                            })
                    }
                })
                .catch(err => {
                    console.log(err)
                })

        } else {

            const data = {
                User_ID: userDatas?.user_and_companies?.[0]?.User_ID,
                ID_Canal: 1,
                Pedido_Feito: formats.dateNow(),
                Pedido_Feito_Hora: formats.hourNow(),
                Valor: qtdTotal,
                Endereco: selectedTab === 1 ? enderecoRetirada : endereco,
                Tipo_Pedido: selectedTab,
                Observacao: obsPedido,
                Cancelado: "", Analise: "", Aprovado: "",
                Faturado: "", Enviado: "", Entregue: "",
                Company_ID: userDatas?.Company_ID,
                ID_Forma_de_Pagamento: payment,
                NParcelas: parcelPayment?.x,
                valorParcelado: parcelPayment?.z,
                completeDates: utimateBoleto ? parcelBoleto : completeDates,
                interval: descBoleto?.interval,
                ultimateBoleto: utimateBoleto
            }

            Order.addCarrinho(data.Company_ID, data.Valor, storedItems)
                .then(response => {

                    if (response.status == 200) {
                        Order.addPedido(data)
                            .then(response => {
                                if (response.status == 200) {
                                    console.log(response.data.menssage)
                                    localStorage.removeItem(`itemCardProd${userDatas?.Company_ID}`)

                                    setShowF(false)
                                    setFetchTimestamp(Date.now());
                                    setFetchTimestampApp(Date.now());
                                }
                            })
                            .catch(err => {
                                console.log(err)
                            })
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    useEffect(() => {
        if (userDatas?.address?.state?.Uf === "PB") {
            return setEnderecoRetirada('Rua Funcionária Pública Geni Ferreira da Silva, 256 - José Américo de Almeida, João Pessoa - PB, 58074-070')
        }
        return setEnderecoRetirada('Av. Coronel Estevam, 3314 - Nossa Sra. de Nazaré, Natal - RN, 59062-200')
    }, [userDatas])
 
    return (
        <>
            <div className='d-flex justify-content-between'>
                <button size='lg' className='btn btn-success' onClick={handleShowF}> Finalizar Compra </button>
            </div>
            {
                size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                    (
                        <Modal
                            show={showF}
                            onHide={handleClose}
                            dialogClassName="modal-custom"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >

                            <Modal.Header closeButton> <Modal.Title> Revise suas informações.</Modal.Title> </Modal.Header>
                            <Modal.Body>

                                <Card className='card-details-seller-modal-lg'>
                                    <Card.Header>Dados da Empresa</Card.Header>
                                    <Card.Body>
                                        <div className='datas-personal-confirm-order'>
                                            <div className='field-name-personal-confirm-order'>
                                                <div>Nome: </div>  <div className='item-confirm-datas form-control w-75' type='text'  > {userDatas?.Corporate_Name}</div>
                                            </div>
                                            <div className='field-name-personal-confirm-order'>
                                                <div>CNPJ: </div>  <div className='item-confirm-datas form-control w-75' type='text' >{formats.formatarCNPJ(userDatas?.CNPJ)}</div>
                                            </div>
                                            <div className='field-name-personal-confirm-order'>
                                                <div>Telefone: </div>  <div className='item-confirm-datas form-control w-75' type='text'> {formats.formatTelefoneFixo(userDatas?.Landline)}</div>
                                            </div>
                                            <div className='field-name-personal-confirm-order'>
                                                <div>Email: </div>  <div className='item-confirm-datas form-control w-75' type='text'   >{userDatas?.Email} </div>
                                            </div>
                                        </div>
                                    </Card.Body>

                                </Card>
                                <br></br>
                                <Card className='card-details-seller-modal-lg'>
                                    <Card.Header>Receber Pedido</Card.Header>
                                    <Card.Body>
                                        <Tabs
                                            defaultActiveKey="Retirar"
                                            id="uncontrolled-tab-example"
                                            className="mb-3"
                                            fill
                                            onSelect={handleSelect} // Captura o evento de seleção
                                        >
                                            <Tab
                                                className="custom-tab-retirar"
                                                eventKey="Retirar"
                                                title="Retirar"
                                            >
                                                <label style={{ fontWeight: '600', marginBottom: '8px' }}>
                                                    Local de Retirada
                                                </label>
                                                <div className='text-secondary'>
                                                    {enderecoRetirada}
                                                </div>
                                            </Tab>

                                            {
                                                habilityEntrega &&

                                                <Tab

                                                    eventKey="Entrega"
                                                    title="Entrega"
                                                >
                                                    <label style={{ fontWeight: '600', marginBottom: '8px' }}>
                                                        Endereço para envio
                                                    </label>
                                                    <textarea
                                                        className="form-control text-secondary "
                                                        onChange={(e) => { setEndereco(e.target.value) }}
                                                        defaultValue={endereco}
                                                    />
                                                </Tab>
                                            }

                                        </Tabs>
                                    </Card.Body>
                                </Card>

                                <hr></hr>
                                <Card>
                                    <Card.Header>Forma de Pagamento</Card.Header>
                                    <Card.Body>
                                        <div>
                                            <Card className={payment == 1 ? 'card-payment-active' : 'card-payment'}
                                                onClick={() => {
                                                    if (payment !== 1) {
                                                        setPayment(1);
                                                        setParcelPayment(1);
                                                    }
                                                }}
                                            >
                                                <Card.Header className={payment == 1 ? 'card-header-payment-active' : 'card-header-payment'}> Cartão de Crédito <div className='icon-payment'><FaCreditCard /></div> </Card.Header>
                                            </Card>
                                            <Card className={payment == 2 ? 'card-payment-active' : 'card-payment'}
                                                onClick={() => {
                                                    if (payment !== 2) {
                                                        setPayment(2);

                                                    }
                                                }}

                                            >
                                                <Card.Header className={payment == 2 ? 'card-header-payment-active' : 'card-header-payment'}>PIX <div className='icon-payment'><FaPix /></div></Card.Header>
                                            </Card>
                                            <Card className={payment == 3 ? 'card-payment-active' : 'card-payment'}

                                                onClick={() => {
                                                    if (payment !== 3) {
                                                        setPayment(3);
                                                        setParcelPayment(1);
                                                    }
                                                }}
                                            >
                                                <Card.Header className={payment == 3 ? 'card-header-payment-active' : 'card-header-payment'}>Boleto Parcelado  <div className='icon-payment'><BsUpc /></div></Card.Header>
                                            </Card>

                                            <Card className={payment == 4 ? 'card-payment-active' : 'card-payment'}
                                                onClick={() => {
                                                    if (payment !== 4) {
                                                        setPayment(4);

                                                    }
                                                }}
                                            >
                                                <Card.Header className={payment == 4 ? 'card-header-payment-active' : 'card-header-payment'}>A vista  <div className='icon-payment'><FaWallet /></div></Card.Header>
                                            </Card>
                                        </div>
                                        <br></br>
                                        {
                                            payment === 1 && (

                                                nParcelas?.length === 0 ?
                                                    (<div className='form-control d-flex justify-content-between align-items-center'>
                                                        <p>Pague ao retirar ou no momento da entrega das suas peças.</p>
                                                    </div>) :
                                                    (
                                                        <>
                                                            <div>
                                                                {parcelasFormatadas?.map((parcela, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <Card
                                                                            className={`card-parcel ${parcelPayment === parcela ? 'card-parcel-payment-active' : ''}`}
                                                                            onClick={() => setParcelPayment(parcela)}
                                                                        >
                                                                            <Card.Header
                                                                                className={` ${parcelPayment === parcela ? 'card-header-payment-active' : ''}`}
                                                                            >
                                                                                {parcela?.a}{parcela?.b}
                                                                            </Card.Header>

                                                                        </Card>
                                                                    </React.Fragment>
                                                                ))}
                                                            </div>
                                                        </>
                                                    )

                                            )
                                        }
                                        {
                                            payment == 2 &&
                                            (
                                                <div className='form-control d-flex justify-content-between align-items-center'>
                                                    <p>Pague ao retirar ou no momento da entrega das suas peças.</p>
                                                </div>
                                            )
                                        }
                                        {
                                            payment === 3 && (
                                                <>
                                                    <div  >
                                                        {parcelasFormatadas?.map((parcela, index) => (
                                                            <React.Fragment key={index}>
                                                                <Card
                                                                    className={`card-parcel ${parcelPayment === parcela ? 'card-parcel-payment-active' : 'card-header-payment-not'}`}
                                                                    onClick={() => setParcelPayment(parcela)}
                                                                >
                                                                    <Card.Header
                                                                        className={`${parcelPayment === parcela ? 'card-header-payment-active' : 'card-header-payment-not'}`}
                                                                    >
                                                                        {parcela?.a}{parcela?.b}
                                                                    </Card.Header>
                                                                </Card>
                                                            </React.Fragment>
                                                        ))}
                                                    </div>

                                                    {
                                                        escolherDataBoletoRN?.length >= 2 ?
                                                            (<div className='text-center'>
                                                                <br></br>
                                                                Escolha uma das opções a baixo
                                                                <div className='area-desc-boleto text-center'>
                                                                    {
                                                                        escolherDataBoletoRN?.map((item, index) => (
                                                                            <React.Fragment key={index}>
                                                                                <div
                                                                                    onClick={() => { handleNewCompleteDatas(item?.completeDates, item?.dates?.interval) }}
                                                                                    className={`  ${completeDates?.[0] == item?.completeDates ? 'item-desc-parcel-active' : 'item-desc-parcel-sele'}`}>
                                                                                    {`Vencimento em ${item?.dates?.interval} dias - ${item?.completeDates}`}
                                                                                </div>
                                                                            </React.Fragment >
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>)
                                                            :
                                                            (<div className='area-desc-boleto'>
                                                                {
                                                                    parcelBoleto?.map((item, index) => (
                                                                        <React.Fragment key={index}>
                                                                            <div className='item-desc-parcel'> {`${index + 1}° Vence em ${item}`}</div>
                                                                        </React.Fragment >
                                                                    ))
                                                                }
                                                            </div>)
                                                    }

                                                </>
                                            )
                                        }
                                        {
                                            payment == 4 &&
                                            (
                                                <div className='form-control d-flex justify-content-between align-items-center'>
                                                    <p>Pague ao retirar ou no momento da entrega das suas peças.</p>
                                                </div>
                                            )
                                        }
                                    </Card.Body>
                                </Card>
                                <hr></hr>
                                <div>
                                    <Card >
                                        <Card.Header>Observação</Card.Header>
                                        <textarea defaultValue={obsPedido} onChange={(e) => { setObsPedido(e.target.value) }} className='form-control' placeholder='Campo não é obrigatório'></textarea>
                                    </Card>
                                    <br></br>
                                    <Card className=' text-center'>
                                        <Card.Header style={{ textAlign: "center", marginLeft: "10px" }}>Total: <strong>{parcelPayment?.b}</strong></Card.Header>
                                        <i>{`em ${parcelPayment?.a} R$ ${formatPrice(qtdTotal)}`}</i>
                                        <Button onClick={handleSendOrder} style={{ margin: "5px" }} variant='warning'>Confirmar</Button>
                                    </Card>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                            </Modal.Footer>
                        </Modal >
                    )
                    :
                    (
                        <Modal
                            show={showF}
                            onHide={handleClose}
                            dialogClassName="modal-custom"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <Modal.Header closeButton> <Modal.Title > Revise suas informações.</Modal.Title> </Modal.Header>
                            <Modal.Body >
                                <div className='d-flex'>
                                    <Card className='card-details-seller-modal-lg'>
                                        <Card.Header>Dados da Empresa</Card.Header>
                                        <Card.Body>
                                            <div className='datas-personal-confirm-order'>
                                                <div className='field-name-personal-confirm-order'>
                                                    <div>Nome: </div>  <div className='item-confirm-datas form-control w-75' type='text'  > {userDatas?.Corporate_Name}</div>
                                                </div>
                                                <div className='field-name-personal-confirm-order'>
                                                    <div>CNPJ: </div>  <div className='item-confirm-datas form-control w-75' type='text' >{formats.formatarCNPJ(userDatas?.CNPJ)}</div>
                                                </div>
                                                <div className='field-name-personal-confirm-order'>
                                                    <div>Telefone: </div>  <div className='item-confirm-datas form-control w-75' type='text'> {formats.formatTelefoneFixo(userDatas?.Landline)}</div>
                                                </div>
                                                <div className='field-name-personal-confirm-order'>
                                                    <div>Email: </div>  <div className='item-confirm-datas form-control w-75' type='text'   >{userDatas?.Email} </div>
                                                </div>
                                            </div>
                                        </Card.Body>

                                    </Card>
                                    <Card className='card-details-seller-modal-lg'>
                                        <Card.Header>Receber Pedido</Card.Header>
                                        <Card.Body>
                                            <Tabs
                                                defaultActiveKey="Retirar"
                                                id="uncontrolled-tab-example"
                                                className="mb-3"
                                                fill
                                                onSelect={handleSelect} // Captura o evento de seleção
                                            >
                                                <Tab
                                                    className="custom-tab-retirar"
                                                    eventKey="Retirar"
                                                    title="Retirar"
                                                >
                                                    <label style={{ fontWeight: '600', marginBottom: '8px' }}>
                                                        Local de Retirada
                                                    </label>
                                                    <div className="form-control">
                                                        {enderecoRetirada}
                                                    </div>
                                                </Tab>

                                                {
                                                    habilityEntrega &&

                                                    <Tab
                                                        className="text-secondary"
                                                        eventKey="Entrega"
                                                        title="Entrega"
                                                    >
                                                        <label style={{ fontWeight: '600', marginBottom: '8px' }}>
                                                            Endereço para envio
                                                        </label>
                                                        <textarea
                                                            className="form-control"
                                                            onChange={(e) => { setEndereco(e.target.value) }}
                                                            defaultValue={endereco}
                                                        />
                                                    </Tab>
                                                }

                                            </Tabs>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <hr></hr>
                                <Card>
                                    <Card.Header>Forma de Pagamento</Card.Header>
                                    <Card.Body>
                                        <div className='d-flex justify-content-between text-center'>
                                            <Card className={payment == 1 ? 'card-payment-active' : 'card-payment'} onClick={() => { setPayment(1); setParcelPayment(1) }}>
                                                <Card.Header className={payment == 1 ? 'card-header-payment-active' : ''}>Cartão de Crédito</Card.Header>
                                                <div className='icon-payment'><FaCreditCard /></div>
                                            </Card>
                                            <Card className={payment == 2 ? 'card-payment-active' : 'card-payment'} onClick={() => { setPayment(2) }}>
                                                <Card.Header className={payment == 2 ? 'card-header-payment-active' : ''}>PIX</Card.Header>
                                                <div className='icon-payment'><FaPix /></div>
                                            </Card>
                                            <Card className={payment == 3 ? 'card-payment-active' : 'card-payment'} onClick={() => { setPayment(3); setParcelPayment(1) }}>
                                                <Card.Header className={payment == 3 ? 'card-header-payment-active' : ''}>Boleto Parcelado</Card.Header>
                                                <div style={{ transform: "scale(1.3)" }} className='icon-payment'><BsUpc /></div>
                                            </Card>
                                            <Card className={payment == 4 ? 'card-payment-active' : 'card-payment'} onClick={() => { setPayment(4) }}>
                                                <Card.Header className={payment == 4 ? 'card-header-payment-active' : ''}>A vista</Card.Header>
                                                <div className='icon-payment'><FaWallet /></div>
                                            </Card>
                                        </div>
                                        <br></br>
                                        {
                                            payment === 1 && (

                                                nParcelas?.length === 0 ?
                                                    (<div className='form-control d-flex justify-content-between align-items-center'>
                                                        <p>Pague ao retirar ou no momento da entrega das suas peças.</p>
                                                    </div>) :
                                                    (
                                                        <>
                                                            < div className='form-control d-flex align-items-center'>
                                                                {parcelasFormatadas?.map((parcela, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <Card
                                                                            className={`card-parcel ${parcelPayment === parcela ? 'card-parcel-payment-active' : ''}`}
                                                                            onClick={() => setParcelPayment(parcela)}
                                                                        >
                                                                            <Card.Header
                                                                                className={`text-center ${parcelPayment === parcela ? 'card-header-payment-active' : ''}`}
                                                                            >
                                                                                {parcela.a}
                                                                            </Card.Header>
                                                                            <Card.Body className='text-center'>
                                                                                <strong>{parcela.b}</strong>
                                                                            </Card.Body>
                                                                        </Card>
                                                                    </React.Fragment>
                                                                ))}
                                                            </div>
                                                        </>
                                                    )

                                            )
                                        }
                                        {
                                            payment == 2 &&
                                            (
                                                <div className='form-control d-flex justify-content-between align-items-center'>
                                                    <p>Pague ao retirar ou no momento da entrega das suas peças.</p>
                                                </div>
                                            )
                                        }
                                        {
                                            payment === 3 && (
                                                <>
                                                    <div className='form-control d-flex  align-items-center'>
                                                        {parcelasFormatadas?.map((parcela, index) => (
                                                            <React.Fragment key={index}>
                                                                <Card
                                                                    className={`card-parcel ${parcelPayment === parcela ? 'card-parcel-payment-active' : ''}`}
                                                                    onClick={() => setParcelPayment(parcela)}
                                                                >
                                                                    <Card.Header
                                                                        className={`text-center ${parcelPayment === parcela ? 'card-header-payment-active' : ''}`}
                                                                    >
                                                                        {parcela?.a}
                                                                    </Card.Header>
                                                                    <Card.Body className='text-center'>
                                                                        <strong>{parcela?.b}</strong>
                                                                    </Card.Body>
                                                                </Card>
                                                            </React.Fragment>
                                                        ))}
                                                    </div>

                                                    {
                                                        escolherDataBoletoRN?.length >= 2 ?
                                                            (<div>
                                                                Escolha uma das opções a baixo
                                                                <div className='area-desc-boleto'>
                                                                    {
                                                                        escolherDataBoletoRN?.map((item, index) => (
                                                                            <React.Fragment key={index}>
                                                                                <div
                                                                                    onClick={() => { handleNewCompleteDatas(item?.completeDates, item?.dates?.interval) }}
                                                                                    className={`  ${completeDates?.[0] == item?.completeDates ? 'item-desc-parcel-active' : 'item-desc-parcel-sele'}`}>
                                                                                    {`Vencimento em ${item?.dates?.interval} dias - ${item?.completeDates}`}
                                                                                </div>
                                                                            </React.Fragment >
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>)
                                                            :
                                                            (<div className='area-desc-boleto'>
                                                                {
                                                                    parcelBoleto?.map((item, index) => (
                                                                        <React.Fragment key={index}>
                                                                            <div className='item-desc-parcel'> {`${index + 1}° Vence em ${item}`}</div>
                                                                        </React.Fragment >
                                                                    ))
                                                                }
                                                            </div>)
                                                    }

                                                </>
                                            )
                                        }
                                        {
                                            payment == 4 &&
                                            (
                                                <div className='form-control d-flex justify-content-between align-items-center'>
                                                    <p>Pague ao retirar ou no momento da entrega das suas peças.</p>
                                                </div>
                                            )
                                        }
                                    </Card.Body>
                                </Card>
                                <hr></hr>
                                <div className='d-flex justify-content-between w-100'>
                                    <Card style={{ width: "70%" }}>
                                        <Card.Header>Observação</Card.Header>
                                        <textarea defaultValue={obsPedido} onChange={(e) => { setObsPedido(e.target.value) }} className='form-control' placeholder='Campo não é obrigatório'></textarea>
                                    </Card>

                                    <Card className='w-25 text-center'>
                                        <Card.Header style={{ textAlign: "center", marginLeft: "10px" }}>Total: <strong>{parcelPayment?.b}</strong></Card.Header>
                                        <i>{`em ${parcelPayment?.a} R$ ${formatPrice(qtdTotal)}`}</i>
                                        <Button onClick={handleSendOrder} style={{ margin: "5px" }} variant='warning'>Confirmar</Button>
                                    </Card>

                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                            </Modal.Footer>
                        </Modal >
                    )
            }


        </>
    )
}

export default FinalizeCart